import TestFormInterface from "../../../Interfaces/TestFormInterface";
import StyledButton from "../../UI/StyledButton";
import StyledInput from "../../UI/StyledInput";
import ReactLoading from "react-loading";
import { useState } from "react";
import { directus } from "../../../Api/FetchDirectus";
import { createItem, registerUser } from "@directus/sdk";
import StyledSelect from "../../UI/StyledSelect";
import { useNavigate } from "react-router-dom";
import StyledPassword from "../../UI/StyledPassword";

const Registration = ({ close, login }: TestFormInterface) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [activity, setActivity] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [loader, setLoader] = useState(false);
  const [ageStatus, setAgeStatus] = useState(false);
  const [genderStatus, setGenderStatus] = useState(false);
  const [activityStatus, setActivityStatus] = useState(false);
  const [jobTitleStatus, setJobTitleStatus] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const [passwordStatus, setPasswordStatus] = useState(false);
  const [passwordRepeatStatus, setPasswordRepeatStatus] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [errorStatus, setErrorStatus] = useState(false);

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  function validatePassword(password: string) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

    if (passwordRegex.test(password)) {
      return true;
    } else {
      return false;
    }
  }

  function onClose() {
    close(false);
  }

  function onChange(e: any, type: string) {
    if (type === "email") {
      setEmail(e.target.value);
    }

    if (type === "password") {
      setPassword(e.target.value);
    }

    if (type === "password_repeat") {
      setPasswordRepeat(e.target.value);
    }
    if (type === "age") {
      setAge(e);
    }

    if (type === "gender") {
      setGender(e);
    }

    if (type === "activity") {
      setActivity(e.target.value);
    }

    if (type === "jobTitle") {
      setJobTitle(e.target.value);
    }
  }

  async function goTest() {
    setLoader(true);
    if (email.trim() === "" || !validateEmail(email)) {
      setEmailStatus(true);
    } else {
      setEmailStatus(false);
    }

    if (password.trim() === "" || !validatePassword(password)) {
      setPasswordStatus(true);
    } else {
      setPasswordStatus(false);
    }

    if (passwordRepeat.trim() === "" || password !== passwordRepeat) {
      setPasswordRepeatStatus(true);
    } else {
      setPasswordRepeatStatus(false);
    }

    if (age.trim() === "" || Number(age) < 16 || Number(age) > 70) {
      setAgeStatus(true);
    }

    if (gender.trim() === "") {
      setGenderStatus(true);
    }

    if (activity.trim() === "") {
      setActivityStatus(true);
    }

    if (jobTitle.trim() === "") {
      setJobTitleStatus(true);
    }

    if (
      validateEmail(email) &&
      validatePassword(password) &&
      password === passwordRepeat &&
      age !== "" &&
      Number(age) >= 16 &&
      Number(age) <= 70 &&
      gender !== "" &&
      activity !== "" &&
      jobTitle !== ""
    ) {
      let result;
      try {
        result = await directus.request(registerUser(email, password));
        try {
          await directus.request(
            createItem("Course_History", {
              email: email,
              form: JSON.stringify({
                age: age,
                gender: gender,
                activity: activity,
                position: jobTitle,
              }),
              date: JSON.stringify(new Date()),
            })
          );
          window.scrollTo(0, 0);
          navigate("/modules");
        } catch (error: any) {
          sessionStorage.removeItem("token");
          navigate("/");
        }
        alert(
          "Для завершения регистрации перейдите по ссылке в письме, отправленном на указанную электронную почту"
        );
        close(false);
        return result;
      } catch (error: any) {
        setErrorStatus(true);
        setErrorText("Возникла ошибка");
        sessionStorage.removeItem("token");
        return;
      }
    }

    setLoader(false);
  }

  function onLogin() {
    login(true);
    close(false);
  }

  return (
    <div className="popUp">
      <div className="popTestForm">
        <div className="closeFormBox">
          <div className="closeFormButton" onClick={onClose}>
            <span></span>
            <span></span>
          </div>
        </div>
        <h2>Регистрация</h2>
        {errorStatus ? <div className="errorText">{errorText}</div> : null}
        {ageStatus ? (
          <div className="errorText">
            {age && (Number(age) < 16 || Number(age) > 70)
              ? "Возраст должен быть от 16 до 70"
              : "Укажите возраст"}
          </div>
        ) : null}
        <StyledInput
          type="number"
          text="Возраст"
          placeholder="Укажите возраст"
          className={ageStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "age")}
        />
        {genderStatus ? <div className="errorText">Укажите пол</div> : null}
        <StyledSelect
          text="Укажите пол"
          optionList={["Мужской", "Женский"]}
          placeholder="Укажите пол"
          className={genderStatus ? "testFormSelect error" : "testFormSelect"}
          onChange={(e: any) => onChange(e, "gender")}
        />
        {activityStatus ? (
          <div className="errorText">Заполните сферу деятельности</div>
        ) : null}{" "}
        <StyledInput
          text="Сфера деятельности"
          placeholder="Укажите сферу деятельности"
          className={activityStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "activity")}
        />
        {jobTitleStatus ? (
          <div className="errorText">Заполните должность</div>
        ) : null}
        <StyledInput
          text="Должность"
          placeholder="Укажите должность"
          className={jobTitleStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "jobTitle")}
        />
        {emailStatus && !validateEmail(email) ? (
          <div className="errorText">Почта введена неверно</div>
        ) : null}
        <StyledInput
          text="Электронная почта"
          placeholder="Укажите вашу электронную почту"
          className={emailStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "email")}
        />
        {passwordStatus && !validatePassword(password) ? (
          <div className="errorText">
            Пароль должен быть не меньше 8 символов, содержать большие и
            маленькие буквы, и цифры
          </div>
        ) : null}
        <StyledPassword
          text="Пароль"
          placeholder="Укажите пароль"
          className={passwordStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "password")}
        />
        {passwordRepeatStatus && password !== passwordRepeat ? (
          <div className="errorText">Пароли должны совпадать</div>
        ) : null}
        <StyledPassword
          text="Повторите пароль"
          placeholder="Укажите пароль ещё раз"
          className={passwordRepeatStatus ? "styledInput error" : "styledInput"}
          onChange={(e: any) => onChange(e, "password_repeat")}
        />
        <div className="testFormStartBox">
          {loader ? (
            <ReactLoading
              type="spinningBubbles"
              color="black"
              height={"50px"}
              width={"50px"}
            />
          ) : (
            <StyledButton
              onClick={() => goTest()}
              className="blueButton testFormButton"
              text="ЗАРЕГИСТРИРОВАТЬСЯ"
            />
          )}

          <div className="switchLogReg" onClick={() => onLogin()}>
            Уже зарегистрированы?
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
